import React from 'react';
import {
  compose,
  withHandlers,
  withProps,
  lifecycle,
  withState,
  withPropsOnChange,
} from 'recompose';
import { get, find, filter } from 'lodash';
import { getService, getConfig } from './_api';
import { Paper, Grid } from '@material-ui/core/';
import withStyles from '@material-ui/core/styles/withStyles';
import moment from 'moment';
import QRCode from 'react-qr-code';
import { allServices } from '../services/_api';
import { itemServiceTypes } from '../../utils/constants/index';

import withLoader from '../app/withLoader';
import { withSnackbar } from 'notistack';
import { removeAccents } from '../../utils/index';

const styles = (theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    padding: 20,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    margin: 15,
  },
  paper2: {
    padding: theme.spacing.unit,
  },
  div: {
    paddingBottom: 20,
  },
  gridItem: {
    marginBottom: 'auto',
    marginTop: 'auto',
  },
});

const enhance = compose(
  withStyles(styles),
  withLoader,
  withSnackbar,
  withProps(
    ({
      match: {
        params: { id },
      },
    }) => {
      return {
        serviceId: id,
      };
    }
  ),
  withState('item', 'setItem', null),
  withState('configQR', 'setConfigQR', null),
  withState('config', 'setConfig', null),
  withState('services', 'setServices', []),
  withHandlers({
    loadItem:
      ({ serviceId, setItem, setConfigQR, setConfig, setServices }) =>
      async () => {
        const [item, config, configQR, services] = await Promise.all([
          getService(serviceId),
          getConfig({ config: 'SERVICE_ATTRIBUTES' }),
          getConfig({ config: 'QR_CODE' }),
          allServices(),
        ]);
        console.log(item);
        if (item) {
          setItem(item);
        }
        setConfig(config);
        setConfigQR(configQR);
        setServices(get(services, 'items', []));
      },
    qrCode:
      ({ item, configQR }) =>
      (itemAdjustment) => {
        return [
          removeAccents(get(item, 'customerName', '')),
          get(itemAdjustment, 'age', ''),
          get(itemAdjustment, 'weight', ''),
          get(itemAdjustment, 'height', ''),
          get(itemAdjustment, 'shoeLength', ''),
          get(itemAdjustment, 'skill', ''),
          get(itemAdjustment, 'shoeBrand', ''),
          get(itemAdjustment, 'skiBrand', ''),
          get(itemAdjustment, 'skiLength', ''),
          get(itemAdjustment, 'skiBindingBrand', ''),
          get(itemAdjustment, 'skiBindingType', ''),
          get(itemAdjustment, 'version', ''),
        ].join('/');
      },
  }),
  lifecycle({
    async componentDidMount() {
      const { serviceId, loadItem, toggleLoader } = this.props;
      toggleLoader();
      await loadItem(serviceId);
      toggleLoader(false);
    },
  }),
  withPropsOnChange(['item', 'configQR', 'services'], ({ item, configQR, services }) => {
    return {
      fields: [
        {
          id: 'customerName',
          label: 'Zákazník',
          value: get(item, 'customerName', ''),
        },
        {
          id: 'date',
          label: 'Termín servisu',
          value: get(item, 'completionDate', false)
            ? `${moment(item.completionDate).format('DD.MM.YYYY, HH:mm')}`
            : '',
        },
        {
          id: 'serviceId',
          label: 'Typ servisu',
          value: get(find(itemServiceTypes, { id: get(item, 'itemServiceType', '') }), 'label', ''),
        },
        {
          id: 'id',
          label: 'Číslo rezervace',
          value: get(item, 'id', ''),
        },
        {
          id: 'status',
          label: 'Stav',
          value: 'přijato',
        },
        {
          id: 'note',
          label: 'Poznámka',
          value: get(item, 'note'),
        },
        {
          id: 'date',
          label: 'Vytvořeno',
          value: get(item, 'createdDate', false)
            ? `${moment(item.createdDate).format('DD.MM.YYYY, HH:mm')}`
            : '',
        },
      ],
    };
  })
);

export default enhance(({ fields, classes, config, configQR, qrCode, item, services }) => (
  <div className={classes.root}>
    <h3>Detail servisu</h3>
    <Paper className={classes.paper}>
      <Grid container={true} spacing={16}>
        {fields.map((field) => (
          <Grid item={true} xs={12} md={4} lg={3} key={field.id}>
            <label className={classes.label}>
              <b>{field.label}</b>
            </label>
            <div>{field.value}</div>
          </Grid>
        ))}
      </Grid>
    </Paper>
    {get(item, 'itemServicesByUser', []).map((service, i) => {
      console.log(get(service, 'serviceAttributes'));
      const serviceAttributes = get(service, 'serviceAttributes')
        ? JSON.parse(get(service, 'serviceAttributes', {}))
        : null;
      const itemAdjustment = get(service, 'itemAdjustment')
        ? JSON.parse(get(service, 'itemAdjustment', {}))
        : null;
      const serviceAttributesFromConfig = find(config, { serviceId: service.serviceId });
      const attributes = get(serviceAttributesFromConfig, 'attributes', []);
      return (
        <Paper className={classes.paper} key={i}>
          <Grid item={true} xs={12} md={4} lg={3}>
            <label className={classes.label}>
              <b>Servis</b>
            </label>
            <div>{get(find(services, { id: get(service, 'serviceId') }), 'name', '')}</div>
          </Grid>
          {serviceAttributes && (
            <React.Fragment>
              <h5>Nastavení servisu</h5>
              {Object.keys(attributes).map((attr) => {
                return (
                  <div>
                    {attr}: {get(serviceAttributes, attr, '')}
                  </div>
                );
              })}
            </React.Fragment>
          )}
          {itemAdjustment && (
            <React.Fragment>
              <h4>Nastavení seřízení vázání s diagnostikou</h4>
              <Grid container={true} spacing={16}>
                {filter(Object.keys(itemAdjustment), (item) => item !== 'version').map((attr) => (
                  <Grid item={true} xs={12} md={4} lg={3} key={attr}>
                    <label className={classes.label}>
                      <b>
                        {get(
                          configQR,
                          `attributeMapping.${attr}`,
                          attr === 'skill' ? 'Lyžařské zkušenosti' : attr
                        )}
                      </b>
                    </label>
                    <div>
                      {!['height', 'shoeLength'].includes(attr)
                        ? get(
                            find(get(configQR, `${attr}Arr`, []), {
                              id: get(itemAdjustment, attr),
                            }),
                            'val'
                          )
                        : `${get(
                            find(get(configQR, `${attr}Arr`, []), {
                              id: get(itemAdjustment, attr),
                            }),
                            'min'
                          )} - ${get(
                            find(get(configQR, `${attr}Arr`, []), {
                              id: get(itemAdjustment, attr),
                            }),
                            'max'
                          )}`}
                      {attr === 'skiLength' ? get(itemAdjustment, attr) : ''}
                    </div>
                  </Grid>
                ))}
                <Grid item={true} xs={12}>
                  <QRCode value={qrCode(itemAdjustment)} />
                </Grid>
                <Grid item={true} xs={12}>
                  {qrCode(itemAdjustment)}
                </Grid>
              </Grid>
            </React.Fragment>
          )}
        </Paper>
      );
    })}
  </div>
));



// WEBPACK FOOTER //
// ./src/modules/item-services/detail.js